<template>
    <div class="prizes">

        <logo modifier="logo--prizes"></logo>

        <div class="prizes-content__title">
            <h1>Választható Nyeremények</h1>
        </div>

        <div class="prizes__text" v-if="filteredPrizes.length > 1">
            <p>Az alábbi nyeremények közül választhat egyet:</p>
        </div>

        <div class="prize-boxes">
            <prize :key="index" v-for="(prize, index) in filteredPrizes" :prize=prize></prize>
        </div>

        <div class="prizes__text">
            <p>Az újrakezdéshez kattinson a nyílra</p>
        </div>

        <router-link class="button-back" :to="{ name: 'homeScreen'}">
            <img src="~@/assets/images/button-prev.png" alt="Home" title="Home">
        </router-link>

    </div>
</template>

<script>
    import Vue from 'vue';
    import Logo from '@/components/shared/LogoElement';
    import Prize from '@/components/prize/PrizeElement';

    export default {
        name: 'Home',
        components: {
            'logo': Logo,
            'prize': Prize
        },
        data: function () {
            return {
                correctCount: Vue.correctCount,
                prizes: Vue.prizesData,
                filteredPrizes: [],
                questions: []
            }
        },

        methods: {
            getQuestions: function () {
                if (localStorage.getItem(Vue.localStorageName)) {
                    this.questions = JSON.parse(localStorage.getItem(Vue.localStorageName));
                }
            },

            countCorrectAnswers: function () {

                var correctCount = 0;

                this.questions.forEach(element => {
                    if (element.correct == element.answered) {
                        correctCount++;
                    }

                    this.correctCount = correctCount;
                });
            }
        },

        mounted() {
            this.getQuestions();
            this.countCorrectAnswers();

            this.prizes.forEach(element => {
                var vm = this;
                if (Number(element.correct) === Number(vm.correctCount)) {
                    vm.filteredPrizes.push(element);
                }
            });
        }

    }
</script>

<style lang="scss">
    .prizes {
        height: 100vh;
        width: 100%;
        background: url('~@/assets/images/background-gray.png');
        text-align: center;
    }

    .prizes-content {

        &__title {

            h1, h2 {
                font-weight: 500;
                font-size: 36px;
                text-transform: uppercase;
                line-height: 86px;
                letter-spacing: 7px;
                margin: 0px;
            }
        }

        &__text {

            p {
                font-size: 18px;
                line-height: 59px;
                text-transform: uppercase;
                margin: 0px 0px 18px 0px;
            }
        }
    }
</style>
